export class ListDataCatalogSemanticLayerRunsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runs",
            "baseName": "runs",
            "type": "Array<DataCatalogSemanticLayerRun>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogSemanticLayerRunsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
